import { useQuery } from 'react-query';
import { apiGetJson } from '~/core/dapi';
import { getInsuranceProfilesForAccount } from '~/core/dapi/insuranceProfile';

type InsuranceProfile = {
  id?: string;
  insurance_profile_id?: string;
  insurer_name: string;
  member_code: string;
  group_number: string;
  insurer_type?: string;
  last_name?: string;
  first_name?: string;
  middle_name?: string;
  birth_date?: string;
  updated_date?: string;
};

const useInsuranceProfilesForAccount = (accountId: string) => {
  const insuranceProfiles = useQuery(
    ['account-insurance-profiles', accountId],
    () => {
      const url = getInsuranceProfilesForAccount(accountId);
      return apiGetJson<InsuranceProfile[]>(url);
    },
    {
      select: (data) => {
        return data?.data;
      },
    }
  );

  return insuranceProfiles;
};

export { useInsuranceProfilesForAccount, InsuranceProfile };
